import React from 'react'
import useUserId from 'App/hooks/useUserId'
import SettingsIcons from 'react-icons/lib/md/settings'

import styles from './styles.css'

export function Inbox({id, name, count, selected, onClick}) {
  return (
    <div
      role="button"
      onClick={() => onClick(id)}
      className={`${styles.inbox} ${selected && styles.selectedInbox}`}>
      <div>{name}</div>
      <div>{count}</div>
    </div>
  )
}

export default function Inboxes({
  inboxes = [],
  onInboxClick,
  configSelected,
  onConfigClick,
  inboxId,
  showInboxList,
  displayConfiguration = false
}) {
  const userId = useUserId()

  const allInbox = inboxes.find(({type}) => type === 'all') || {}
  const mineInbox = Object.assign(inboxes.find(({_id}) => _id === userId) || {}, {
    name: 'Tus chats',
    _id: userId
  })
  const countryInboxes = inboxes.filter(({type}) => type === 'country')
  const agentInboxes = inboxes.filter(({type, _id}) => type === 'agent' && _id !== userId)
  const priority = inboxes.filter(({type}) => type === 'priority')

  function renderInbox({_id = 'all', name, count}) {
    return (
      <Inbox
        key={_id}
        name={name}
        id={_id}
        count={count}
        selected={inboxId === _id}
        onClick={onInboxClick}
      />
    )
  }

  return (
    <div className={[styles.inboxes, !showInboxList && styles.collapsed].filter(Boolean).join(' ')}>
      <div>
        <div className={styles.inboxTitle}>
          <h1>Inboxes</h1>
        </div>
        {[allInbox, mineInbox].map(renderInbox)}
        <div className={styles.inboxTitle}>
          <h4>Países</h4>
        </div>
        {countryInboxes.map(renderInbox)}
        <div className={styles.inboxTitle}>
          <h4>Prioridad</h4>
        </div>
        {priority.map(renderInbox)}
        <div className={styles.inboxTitle}>
          <h4>Equipo</h4>
        </div>
        {agentInboxes.map(renderInbox)}
      </div>
      {displayConfiguration ? (
        <div
          role="button"
          className={[styles.config, configSelected && styles.selectedInbox].join(' ')}
          onClick={onConfigClick}>
          <div>Configuración</div>
          <SettingsIcons />
        </div>
      ) : null}
    </div>
  )
}
